export enum SnsBtnTypeCode {
  Default = 'Default',
  Login = 'Login',
  Join = 'Join',
}
